import {StrengthParameters} from "../_validators";

export const accountPasswordStrengthParams: StrengthParameters = {
	minLettersCount: 2,
	minNumbersCount: 1,
	minSpecialCharsCount: 1
};